// Servicio API para FeelLab CMS
const API_URL = 'https://feellab.org/api';

class ApiService {
  async request(endpoint) {
    try {
      const response = await fetch(`${API_URL}${endpoint}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // News
  async getNews(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/public/news${query ? '?' + query : ''}`);
  }

  async getNewsBySlug(slug) {
    return this.request(`/public/news/${slug}`);
  }

  // Gallery
  async getGallery() {
    return this.request('/public/gallery');
  }

  // Videos
  async getVideos() {
    return this.request('/public/videos');
  }

  // Team
  async getTeam() {
    return this.request('/public/team');
  }

  // Content
  async getContent() {
    return this.request('/public/content');
  }

  // Categories
  async getCategories(type) {
    return this.request(`/public/categories/${type}`);
  }
}

export default new ApiService();